<div
  #countrySelect
  class="country-select-container country-select-{{ fieldKey }}"
  [style.--country-select-min-width]="minWidthCssVariable">
  <!-- LABEL -->
  <label [id]="'label-countrySelect-' + fieldKey" [class.invalid]="fieldControl.touched && fieldControl.invalid">
    {{ 'PERSONAL_DATA_FORM.' + fieldLabelKey + '.MAIN-LABEL' | translate }}

    @if (isRequired) {
      <span aria-hidden="true">&nbsp;*</span>
      <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
    }
  </label>

  <!-- INPUT -->
  @if (countriesList?.length) {
    <ng-select
      [id]="'countrySelect-' + fieldKey"
      [searchable]="true"
      class="select-short-dropdown"
      dropdownPosition="bottom"
      bindLabel="label"
      bindValue="value"
      appendTo="body"
      [placeholder]="'PERSONAL_DATA_FORM.' + fieldLabelKey + '.PLACEHOLDER' | translate"
      [formControl]="fieldControl"
      [items]="countriesList"
      [required]="isRequired"
      [inputAttrs]="{
        autocomplete: 'off',
        'aria-required': isRequired ? 'true' : 'false',
        'aria-invalid': fieldControl.invalid && fieldControl.touched ? 'true' : 'false',
        'aria-labelledby': 'label-countrySelect-' + fieldKey,
        'aria-describedby': fieldControl.invalid && fieldControl.touched ? 'error-countrySelect-' + fieldKey : null,
      }">
    </ng-select>
  }

  <!-- ERROR -->
  @if (fieldControl.touched && fieldControl.invalid) {
    <div [id]="'error-countrySelect-' + fieldKey" role="alert" class="ng-select-error">
      {{ fieldControl.errors | errorsFormatingAndTranslate }}
    </div>
  }
</div>
